import React from 'react';
import ModalPopup from './ModalPopup';
import completed from '../../../images/completed.svg';
import failed from '../../../images/failed.svg';

const ErrorModal = ({ isVisible, message, allowConfirm, onClose }) => {
  let title = '錯誤';
  let content = (
    <div style={{ textAlign: 'center' }}>
      <img src={failed} />
      <p>{message}</p>
    </div>
  );

  return (
    <ModalPopup
      isVisible={isVisible}
      onClose={onClose}
      title={title}
      content={content}
      allowConfirm={allowConfirm}
      isInsurance={false}
    />
  );
};

export default ErrorModal;
